<div class="checkout-step checkout-payment-method">
  <div class="checkout-step-content">
    <span class="label-step">Selecione a forma de pagamento: </span>
    <div class="payment-method-options">
      <label class="radio-option" [class.selected]="selectedMethod === 'PIX'">
        <input type="radio" name="paymentMethod" value="PIX" [checked]="selectedMethod === 'PIX'" (change)="onMethodChange('PIX')" />
        <span class="radio-option-label"><strong>PIX</strong></span>
      </label>

      <label class="radio-option" [class.selected]="selectedMethod === 'CREDIT_CARD'">
        <input
          type="radio"
          name="paymentMethod"
          value="CREDIT_CARD"
          [checked]="selectedMethod === 'CREDIT_CARD'"
          (change)="onMethodChange('CREDIT_CARD')"
        />
        <span class="radio-option-label"
          ><strong>{{ 'checkout.paymentMethod.creditCard' | translate }}</strong></span
        >
      </label>

      <label class="radio-option" [class.selected]="selectedMethod === 'BOLETO'">
        <input
          type="radio"
          name="paymentMethod"
          value="BOLETO"
          [checked]="selectedMethod === 'BOLETO'"
          (change)="onMethodChange('BOLETO')"
        />
        <span class="radio-option-label"
          ><strong>{{ 'checkout.paymentMethod.boleto' | translate }}</strong></span
        >
      </label>
    </div>
  </div>
</div>
